// extracted by mini-css-extract-plugin
export default {"section":"ShipmentStatus_section__Obzwq"};